/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/common/EnterpriseNewConnection.Props" />
import { ExternalConnection } from "Wit/Clients/Internal/Contracts/WorkItemTracking";
import { Panel } from "Wit/Settings/BoardsExternalIntegration/components/panels/Panel.enum";

export interface IEnterpriseNewConnectionProps {
    disableOAuth: boolean;
    showPanel: (panel: Panel, connection?: ExternalConnection) => void;
}
